// src/modules/app-views/_apps/applekkus/landingPages/pages/Init/components/tableColumns/urlColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function urlColumn(buildColumnProps, options = {}) {
  const {
    key = 'url',
    title = 'url',
    dataIndex = 'deployUrl',
    width = 200,
    columnProps = {},
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    className: 'text-truncate',
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const url = r?.deployUrl;
      if (!url) return <span>—</span>;
      return (
        <Typography.Link href={url} target="_blank" rel="noopener noreferrer">
          {url}
        </Typography.Link>
      );
    },
  };
}

export default urlColumn;
